import React, { useEffect, useState } from 'react';
import '../styles/components/Loader.css';

const Loader = ({ fullScreen = true, message = "Loading..." }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const logoPath = process.env.PUBLIC_URL + '/landtfinancelogo.svg';
  
  useEffect(() => {
    // Set loader as loaded after a short delay to trigger animations
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Style objects for perfect centering
  const containerStyle = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0
  };
  
  const wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    padding: 0,
    width: '220px', // Increased from 180px to 220px
    height: '150px', // Increased from 120px to 150px
    position: 'relative'
  };
  
  const logoStyle = {
    width: '200px', // Increased from 160px to 200px
    height: 'auto',
    display: 'block',
    margin: '0 auto',
    position: 'relative',
    left: '0' // Removed left offset to center the logo perfectly
  };
  
  // Create a wrapper div to contain both logo and text in a vertically centered group
  const contentGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '45%', // Shifted slightly up from 50% to account for text height
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    margin: 0,
    padding: 0
  };
  
  const textStyle = {
    marginTop: '0px', // Reduced from 5px to 0px for even tighter spacing
    fontSize: '18px',
    fontWeight: '600',
    color: '#FFFFFF', // White text color
    textAlign: 'center',
    padding: 0
  };
  
  return (
    <div 
      className={`loader-container ${!fullScreen ? 'loader-inline' : ''}`}
      style={containerStyle}
    >
      <div style={contentGroupStyle}>
        <div 
          className={`logo-loader-wrapper ${isLoaded ? 'loaded' : ''}`}
          style={wrapperStyle}
        >
          {/* Animated outline border */}
          <div className="logo-outline-container">
            <div className="logo-outline top"></div>
            <div className="logo-outline right"></div>
            <div className="logo-outline bottom"></div>
            <div className="logo-outline left"></div>
          </div>
          
          {/* Logo image - centered with inline styles for guaranteed centering */}
          <div className="logo-image-container">
            <img 
              src={logoPath} 
              alt="L&T Finance Logo" 
              className="logo-loader"
              style={logoStyle}
            />
          </div>
          
          {/* Pulsing effect */}
          <div className="logo-pulse"></div>
        </div>
        
        {message && <p className="loading-text" style={textStyle}>{message}</p>}
      </div>
    </div>
  );
};

export default Loader;